import { gql } from '@apollo/client'
import { Chip, Heading, RadioCard } from '@farol-ds/react'
import { Price } from '@jusbrasil-web/shared-price'

import { PlanFrequency } from '../../../../constants'
import { FrequencyOption_OfferLockCardFragment } from './__generated__/frequency-option.graphql'
import styles from './frequency-option.module.scss'

interface FrequencyOptionProps {
  title: string
  offerLockCard: FrequencyOption_OfferLockCardFragment
}

export function FrequencyOption({ title, offerLockCard }: FrequencyOptionProps) {
  const { chip, offer } = offerLockCard
  const chipLabel = chip?.label

  const {
    priceTitle,
    priceText,
    frequencyPeriodText,
    priceAfterPromotionalPeriodText,
    frequency,
    installmentsText,
  } = offer

  const isPromotional = !!priceAfterPromotionalPeriodText
  const isYearly = frequency === PlanFrequency.YEARLY
  const showInstallmentsBeforePrice = isYearly && !isPromotional && installmentsText

  return (
    <RadioCard.Content>
      <RadioCard.ContentTitle className={styles.optionTitle}>
        <Heading size="md">{title}</Heading>

        {chipLabel && (
          <Chip size="sm" kind="secondary" className={styles.optionTitleChip}>
            <span dangerouslySetInnerHTML={{ __html: chipLabel }} />
          </Chip>
        )}
      </RadioCard.ContentTitle>

      <RadioCard.ContentDescription>
        <Price align="left" size="md">
          <Price.Value className={styles.priceValue}>
            {showInstallmentsBeforePrice && (
              <Heading size="sm" className={styles.installments}>
                {installmentsText}
              </Heading>
            )}

            {showInstallmentsBeforePrice && ' '}

            {priceText}

            {isPromotional ? (
              <Price.Helptext> no {frequencyPeriodText}</Price.Helptext>
            ) : (
              <>{!isYearly && <Price.ValueFrequency>{frequency}</Price.ValueFrequency>}</>
            )}
          </Price.Value>

          {priceTitle && (
            <Price.Helptext>
              <span dangerouslySetInnerHTML={{ __html: priceTitle }} />
            </Price.Helptext>
          )}
        </Price>
      </RadioCard.ContentDescription>
    </RadioCard.Content>
  )
}

FrequencyOption.fragments = {
  offerLockCard: gql`
    fragment FrequencyOption_offerLockCard on OfferLockCard {
      chip {
        label
      }
      offer {
        priceTitle
        priceText
        frequencyPeriodText
        priceAfterPromotionalPeriodText
        frequency
        installmentsText
      }
    }
  `,
}
